import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation, usePermissions } from "hooks";

import { translations } from "./translations";

import {
  PaginateAlertsActions,
  PaginateAlertsState,
} from "store/ducks/settings/alerts";

import { SelectedFilterActions, SelectedFilterState } from "store/ducks/filter";

import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridAlerts, FilterAlerts } from "components/settings";
import * as S from "./styles";
import { useFilters } from 'hooks/useFilters';

export const ListAlerts: React.FC = () => {
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();
    const { getData } = useFilters('alerts');

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateAlerts
  ) as PaginateAlertsState;

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")} <MenuSelector page="alerts" />
          {loading && <S.LoadingPage />}
        </h1>

        <S.HeaderButtons>
          {checkUserPermission("insertAlert") && (
            <S.ButtonMini onClick={() => history.push("/settings/alert/new")}>
              {getTranslation("novoAlerta")}
            </S.ButtonMini>
          )}
          <FilterAlerts />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridAlerts alerts={data} />
        <Paginator
          pagination={pagination}
          settingsPage='alerts'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
